import 'react-datepicker/dist/react-datepicker.css'

import React from 'react';
import { validated } from 'react-custom-validation';

import { generateFileUrl } from 'utils/request';
import { isRequired } from 'utils/validations';
import { FILE_UPLOAD_LOCATIONS } from 'utils/constants';

import Form from 'components/Form/index';
import FormError from 'components/FormError/index';
import FormRow from 'components/FormRow/index';
import FormValidationMessage from 'components/FormValidationMessage/index';
import Icon from 'components/Icon/index';
import Input from 'components/Input/index';
import ModalButton from 'components/ModalButton/index';
import ModalFileUpload from 'components/ModalFileUpload/index';
import TextArea from 'components/TextArea/index';

import { FILE_TYPES } from 'utils/constants';

class AssignmentEditForm extends React.Component {
    static propTypes = {
        adminEmail: React.PropTypes.string.isRequired,
        closeModal: React.PropTypes.func.isRequired,
        contentError: React.PropTypes.object,
        contentPiece: React.PropTypes.object.isRequired,
        fileToUpload: React.PropTypes.object,
        handleChange: React.PropTypes.func.isRequired,
        handleFileSelectedToUpload: React.PropTypes.func.isRequired,
        isSaving: React.PropTypes.bool.isRequired,
        onValid: React.PropTypes.func.isRequired,
        onInvalid: React.PropTypes.func.isRequired
    };

    _handleFileDrop(file) {
        if(FILE_TYPES[file[0].type] === 'Video') {
            file[0].blob = window.URL.createObjectURL(file[0]);
        }
        this.props.handleFileSelectedToUpload(file[0]);

    }

    _generatePreviewHtml() {
        if(this.props.fileToUpload) {
            let fileTypeString = FILE_TYPES[this.props.fileToUpload.type];
            if (fileTypeString === 'Image' || fileTypeString === 'GIF') {
                return (
                    <div className="modal__dropzone-preview">
                        <img src={this.props.fileToUpload.preview} role="presentation" />
                    </div>
                )
            } else if (fileTypeString === 'Video') {
                return (
                    <div className="modal__dropzone-preview">
                        <video src={this.props.fileToUpload.blob} controls/>
                    </div>
                )
            } else {
                return (
                    <div className="modal__dropzone-preview">
                        <Icon icon="document"/>
                        <strong>Upload: </strong>{this.props.fileToUpload.name}
                    </div>
                )
            }
        } else {
            let fileTypeString = FILE_TYPES[this.props.contentPiece.file.contentType];
            if (fileTypeString === 'Image' || fileTypeString === 'GIF') {
                return (
                    <div className="modal__dropzone-preview">
                        <img src={generateFileUrl(this.props.contentPiece.file, this.props.adminEmail, FILE_UPLOAD_LOCATIONS.UPLOAD)} role="presentation" />
                        <Icon icon="edit" className="modal__dropzone-preview-edit" />
                    </div>
                )
            } else if (fileTypeString === 'Video') {
                return (
                    <div className="modal__dropzone-preview">
                        <video src={generateFileUrl(this.props.contentPiece.file, this.props.adminEmail, FILE_UPLOAD_LOCATIONS.UPLOAD)} controls/>
                        <Icon icon="edit" className="modal__dropzone-preview-edit" />
                    </div>
                )
            } else {
                return (
                    <div className="modal__dropzone-preview">
                        <Icon icon="document"/>
                        <strong>Uploaded: </strong>{this.props.contentPiece.file.clientFileName}
                        <Icon icon="edit" className="modal__dropzone-preview-edit" />
                    </div>
                )
            }
        }
    }

    render() {
        let { closeModal, contentError, contentPiece, fileToUpload, handleChange, isSaving, onValid, onInvalid, $field, $validation } = this.props;

        return (
            <Form className="content-edit__form modal-form">
                <FormRow>
                    <Input type="text"
                           name="name"
                           placeholder="Name"
                           value={contentPiece.name}
                           {...$field('name', (event) => handleChange(event))}
                           onChange={handleChange.bind(this)} />
                    {$validation.name.show && <FormValidationMessage>{$validation.name.error.reason}</FormValidationMessage>}
                </FormRow>

                <FormRow className="content-edit__file-upload">
                    <ModalFileUpload accept={Object.keys(FILE_TYPES).join(',')}
                                     fileToUpload={fileToUpload}
                                     generatePreview={this._generatePreviewHtml.bind(this)}
                                     handleFileDrop={this._handleFileDrop.bind(this)}
                                     hasFile={contentPiece.file != null} />
                    {$validation.fileToUpload.show && <FormValidationMessage>{$validation.fileToUpload.error.reason}</FormValidationMessage>}
                </FormRow>

                <FormRow>
                    <TextArea name="description"
                              placeholder="Description"
                              className="content-edit__description"
                              onChange={handleChange.bind(this)}
                              value={contentPiece.description} />
                </FormRow>

                <FormError show={Object.keys(contentError).length > 0}>
                    {contentError.friendlyMessage ? contentError.friendlyMessage : contentError.message}
                </FormError>

                <div className="modal__buttons">
                    <ModalButton disabled={isSaving === true}
                                 icon="check"
                                 onClick={(event) => {
                                     event.preventDefault();
                                     this.props.$submit(onValid, onInvalid)}}
                                 text="Done" />
                    <ModalButton className="modal-button--cancel"
                                 disabled={isSaving === true}
                                 icon="cancel"
                                 onClick={closeModal.bind(this)}
                                 text="Cancel" />
                </div>
            </Form>
        )
    }
};

function assignmentEditFormValidationConfig(props) {
    const { name, file } = props.contentPiece;
    const { fileToUpload } = props;
    return {
        fields: ['fileToUpload', 'name'],
        validations: {
            fileToUpload: [
                [isRequiredIfFileDoesntExist, fileToUpload, file]
            ],
            name: [
                [isRequired, name]
            ]
        }
    }
}



function isRequiredIfFileDoesntExist(value, file) {
    if(file != null && Object.keys(file).length > 0) {
        return null;
    } else {
        return value != null && value !== '' ? null : 'You must upload a file.';
    }
};

export default AssignmentEditForm = validated(assignmentEditFormValidationConfig)(AssignmentEditForm);




// WEBPACK FOOTER //
// ./src/containers/ContentPage/modals/FileUploadEditModal/FileUploadEditForm.js